import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// Attach access token and account-ID to all requests
api.interceptors.request.use(config => {
  const access = localStorage.getItem('access');
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }

  const accountId = localStorage.getItem('current_account_id');
  if (accountId) {
    config.headers['X-Account-ID'] = accountId;
  }

  return config;
});

// Handle 401 → try refresh → logout if failed
// Refresh token flow
api.interceptors.response.use(
  res => res,
  async err => {
    const originalRequest = err.config;

    // Prevent infinite loop
    if (originalRequest.url?.includes('/auth/token/refresh/')) {
      return Promise.reject(err);
    }

    const refresh = localStorage.getItem('refresh');

    if (
      err.response?.status === 401 &&
      !originalRequest._retry &&
      refresh
    ) {
      originalRequest._retry = true;

      try {
        const { data } = await api.post('/auth/token/refresh/', { refresh });

        // Update access token
        localStorage.setItem('access', data.access);

        // Update refresh token only if a new one is provided (token rotation)
        if (data.refresh) {
          localStorage.setItem('refresh', data.refresh);
        }

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${data.access}`;

        // 🔥 Fix: add X-Account-ID back
        const accountId = localStorage.getItem('current_account_id');
        if (accountId) {
          originalRequest.headers['X-Account-ID'] = accountId;
        }

        return api(originalRequest);
      } catch (e) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(e);
      }
    }

    return Promise.reject(err);
  }
);


export default api;
